"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _iterables = require("rich-text-lib/utils/iterables");

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _sizes = require("HubStyleTokens/sizes");

var _withTinyMcePopoverLifecycle = _interopRequireDefault(require("../hoc/withTinyMcePopoverLifecycle"));

var TinyMcePopover =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TinyMcePopover, _Component);

  function TinyMcePopover(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TinyMcePopover);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TinyMcePopover).call(this, props));
    _this.zIndex = props.editor.settings.inline && !props.isToolbarPopover ? Number(_sizes.EARTH_LAYER) : Number(_sizes.JUPITER_LAYER);
    return _this;
  }

  (0, _createClass2.default)(TinyMcePopover, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIPopover.default, (0, _extends2.default)({}, (0, _iterables.omit)(['editor', 'onRemove', 'zIndex', 'isToolbarPopover'], this.props), {
        zIndex: this.zIndex
      }));
    }
  }]);
  return TinyMcePopover;
}(_react.Component);

TinyMcePopover.propTypes = (0, _extends2.default)({}, _UIPopover.default.propTypes, {
  open: _react.PropTypes.bool,
  isToolbarPopover: _react.PropTypes.bool
});
TinyMcePopover.defaultProps = (0, _extends2.default)({}, (0, _iterables.omit)(['placement', 'arrowSize'], _UIPopover.default.defaultProps), {
  arrowSize: 'medium',
  placement: 'right bottom',
  open: true,
  isToolbarPopover: false
});

var _default = (0, _withTinyMcePopoverLifecycle.default)(TinyMcePopover);

exports.default = _default;
module.exports = exports.default;